<template>
  <el-container>
    <el-aside class="aside-container" width="230px">
      <Aside></Aside>
    </el-aside>
    <el-container>
      <el-header class="header_con">
        <Header></Header>
      </el-header>
      <el-header style="padding-top: 0" class="bread_con" height="40px">
        <Bread :breadList="breadcrumbsData"></Bread>
      </el-header>
      <el-scrollbar class="main-scrollbar">
        <el-main>
          <!-- {{ result.title }} -->
          <RouterView></RouterView>
          <!-- <Main/> -->
        </el-main>
      </el-scrollbar>
    </el-container>
  </el-container>
</template>

<script>
import Aside from "./Aside";
// import Main from "./Main";
import Header from "./Header";
import Bread from "@/Layout/Main/bread.vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { computed, watch, ref, provide, reactive, onMounted } from "vue";
export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const out = () => {
      router.push("/login");
    };
    let breadcrumbsData = computed(() => store.getters.newRouteschildrenrouter);
    // let breadcrumbsData = computed(() => route.matched);
    console.log("当前左侧菜单", breadcrumbsData.value);

    // 二级面包屑
    let result = reactive({
      title: "",
      meta: {},
    });
    // 监听路由变化来更新面包屑数据
    let BreadTilte = ref();
    // 监听路由变化来更新面包屑数据
    watch(
      route,
      () => {
        breadcrumbsData.value.forEach((item) => {
          if (item.path === route.path) {
            result.title = item.title;
            result.meta = item.meta;
            if (item.children) {
              const child = item.children.find(
                (child) => child.path === route.path
              );
              if (child) {
                result.title = child.title;
                result.meta = child.meta;
              }
            }
          } else if (item.children) {
            const child = item.children.find(
              (child) => child.path === route.path
            );
            if (child) {
              result.title = child.title;
              result.meta = child.meta;
            }
          } else if (item.children) {
            const child = item.children.find(
              (child) => child.path === route.path
            );
            if (child) {
              result.title = child.title;
              result.meta = child.meta;
            }
          }
        });
      },
      { immediate: true, deep: true }
    );

    // 打印面包屑数据，用于调试
    console.log(result, "---------------result---------------");

    // 提供响应性数据
    provide("BreadTilte", result);
    // router.beforeEach((to, from, next) => {
    //   next();
    // });

    return {
      BreadTilte,
      result,
      out,
      breadcrumbsData,
    };
  },
  methods: {},
  components: {
    Header,
    // Main,
    Aside,
    Bread,
  },
};
</script>

<style scoped lang="scss">
:deep(.main-scrollbar) {
  width: calc(100vw - 180px) !important;
}

// 顶部div
.el-header {
  //   border-left: 1px solid rgb(50, 83, 149);
  background-color: #343a52;
  color: #fff;
  text-align: center;
  // line-height: 60px;
}

.el-footer {
  background-color: #fff;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-header:nth-child(2) {
  background-color: #fafafa;
  padding-top: 10px;
  // line-height: 60px;
  padding-left: 24px;
}

.el-aside {
  width: 180px;
  background-color: #343a52;
  color: #333;
  line-height: 200px;
  overflow-x: hidden;
  height: 100%;
}

.el-aside::-webkit-scrollbar {
  width: 6px;
}

.main-scrollbar {
  width: calc(100vw - 230px);
  height: calc(100vh - 60px);
  // margin-left: 230px;
  box-sizing: border-box;
  background-color: #f2f3fb;
}

.el-main {
  background-color: #e9eef3;
  background-color: #f2f3fb;

  color: #333;
  text-align: center;
}

.el-container {
  height: 100vh;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.bread_con {
  display: flex;
  align-items: center;
}
</style>